/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminRerunSideEffectsRequestModelApiModel } from '../../models/admin-rerun-side-effects-request-model-api-model';

export interface RerunSideEffects$Params {
      body: AdminRerunSideEffectsRequestModelApiModel
}

export function rerunSideEffects(http: HttpClient, rootUrl: string, params: RerunSideEffects$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, rerunSideEffects.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

rerunSideEffects.PATH = '/admin/rerun-side-effects';
